export default __webpack_public_path__ + "static/floatingImg5-324211db3b441c0087afe908bd1e3ca2.webp";